import { useDispatch, useSelector } from "react-redux";
import { setOpen } from "../redux-store/features/chatDQPSlice";

const useChatDQP = () => {
  const dispatch = useDispatch();
  const open =
    useSelector(
      (state) => state.chatDQP.open
    );

  const setOpenChatDQP = (isOpen) => {
    dispatch(setOpen(isOpen));
  }

  return { open, setOpen: setOpenChatDQP };
};

export default useChatDQP;
